function isArray(value) {
  return Array.isArray(value);
}

function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}

function isUndefined(value) {
  return typeof value === 'undefined';
}

function isDefined(value) {
  return !isUndefined(value);
}

function isNull(value) {
  return value === null;
}

function isNullLike(value) {
  return isNull(value) || isUndefined(value);
}
function isFunction(value) {
  return typeof value === 'function';
}

function isString(value) {
  return typeof value === 'string';
}

function isEmptyString(value) {
  return isString(value) && value.length === 0;
}

function isEmptyStringLike(value) {
  return isNullLike(value) || isEmptyString(value);
}

function isNonEmptyString(value) {
  return isString(value) && value.length > 0;
}

function isChar(value) {
  return isString(value) && value.length === 1;
}

function isDigit(char) {
  return isChar(char) && /\d/.test(char);
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function isBooleanLike(value) {
  return isBoolean(value) || isTrueString(value) || isFalseString(value);
}

function isTrueLike(value) {
  if (isBoolean(value)) {
    return value;
  }

  return isTrueString(value);
}

function isFalseLike(value) {
  if (isBoolean(value)) {
    return !value;
  }

  return isFalseString(value);
}

function isTrueString(value) {
  return isString(value) && value.toLowerCase() === 'true';
}

function isFalseString(value) {
  return isString(value) && value.toLowerCase() === 'false';
}

function isDate(value) {
  return Object.prototype.toString.call(value) === '[object Date]';
}

function isDateString(value) {
  if (!isString(value)) {
    return false;
  }

  if (value.length !== 10) {
    return false;
  }

  return /^\d{4}-\d{2}-\d{2}$/.test(value);
}

function isDateISOString(value) {
  if (!isString(value)) {
    return false;
  }

  if (value.length !== 24) {
    return false;
  }

  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value);
}

function isDateLike(value) {
  return isDate(value) || isDateISOString(value);
}

function isNumber(value) {
  return typeof value === 'number';
}

function isInRange(value, { min, max }) {
  return value >= min && value <= max;
}

function isFinite(value) {
  // eslint-disable-next-line no-undef
  return isNumber(value) && globalThis.isFinite(value);
}

function isInteger(value) {
  return isNumber(value) && value === parseInt(value, 10);
}

function isSafeInteger(value) {
  return isInteger(value) && value >= -Number.MAX_SAFE_INTEGER && value <= Number.MAX_SAFE_INTEGER;
}

function isNatural(value) {
  return isInteger(value) && value >= 0;
}

function isObject(value) {
  return typeof value == 'object' && !isNull(value) && !isArray(value);
}

function isPlainObject(value) {
  return isObject(value) && value.constructor == Object;
}

function isEmptyObject(value) {
  return isPlainObject(value) && Object.keys(value).length === 0;
}

function isEmptyLike(value) {
  return isEmptyStringLike(value) || isEmptyArray(value) || isEmptyObject(value);
}

function isPrimitive(value) {
  return isString(value) || isNumber(value) || isBoolean(value) || isNullLike(value);
}

export { isArray, isBoolean, isBooleanLike, isChar, isDate, isDateISOString, isDateLike, isDateString, isDefined, isDigit, isEmptyArray, isEmptyLike, isEmptyObject, isEmptyString, isEmptyStringLike, isFalseLike, isFalseString, isFinite, isFunction, isInRange, isInteger, isNatural, isNonEmptyString, isNull, isNullLike, isNumber, isObject, isPlainObject, isPrimitive, isSafeInteger, isString, isTrueLike, isTrueString, isUndefined };
